import 'moment-timezone'
import React, { memo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ColetaClickstream from '../../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../../conexoes/api.js'
import {
  desabilitarAcoes,
  desabilitarAcoesCliente,
  limpadorFiltros,
  limpouBusca,
  modoSelecaoSimcard,
  mudarBuscaArquivo,
  mudarFiltros,
  mudarPermissaoElementoAcao,
  realizouBusca,
  realizouFiltro,
  revelarAlteracaoprazodepermanenciaFaturas,
  revelarAlterarICCIDFaturas,
  revelarBarraFiltragem,
  RevelarBuscarEFiltro,
  revelarDesativarSMSFaturas,
  revelarDispositivosAlterarCicloDeVida,
  revelarDispositivosAlterarConta,
  revelarDispositivosAlterarPlano,
  revelarDispositivosAlterarServicos,
  revelarLiberarSMSFaturas,
  revelarRelatorioFaturaDispositivos,
  revelarResetFaturas,
  separadorLinhaBusca
} from '../../../../redux/actions/index'
import decryptJWT from '../../../../utils/decryptJWT'
import {
  getListaIccidsNaoEncontrados,
  getListaLinhasNaoEncontradas,
  montarXlsLinhasNaoEncontradas
} from '../../../../utils/exportarArquivo'
import { limiteSolicitacoes } from '../../../../utils/solicitacoes'
import { validadorPermissaoElemento } from '../../../../utils/verificadorPermissaoElemento'
import {
  AtencaoBaixarArquivoLinhasNaoEncontradas,
  BotaoInvisivelExportarLinhasNaoEncontradas,
  clickBotaoInvisivelExportarLinhasNaoEncontradas
} from '../../../buscaArquivo'
import { RenderMensagemSucesso } from '../../../componentesModais/mensagens/mensagemAcao'
import MensagemAtencao from '../../../componentesModais/mensagens/mensagemAtencao'
import MensagemInformacao from '../../../componentesModais/mensagens/mensagemInformacao'
import PersonalizarColunasFaturas from '../../../personalizarColunasFaturas/personalizarColunasFaturas'
import {
  clickDesselecionarCheckboxVerde,
  desselecionarTodosCheckboxes
} from '../../../tabelaSelecao/checkboxSelecao'
import Table from '../../../Table/index.jsx'
import ModalAssociarClientes from '../../fatFebraban/associarFatura/associarFatura'
import AlterarCicloDeVida from '../acoes/alterarCicloDeVida'
import AlterarConta from '../acoes/alterarConta'
import AlterarIccid from '../acoes/alterarIccid'
import AlterarPlano from '../acoes/alterarPlano'
import AlterarPrazoPermanencia from '../acoes/alterarPrazoPermanencia'
import AlterarServico from '../acoes/alterarServico'
import ImportarDescricao from '../acoes/ImportarDescricao'
import Reset from '../acoes/reset'
import BloquearSms from '../acoes/smsBloquear'
import LiberarSms from '../acoes/smsLiberar'
import Detalhamento from '../detalhamento/detalhamento'

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 50
let operadorasSelecionadas = []
let itensVar = []
let ordem = {}
let alternadorSelecao = false
let simcardsArray = []
const valorLimite = 50
let chaveArquivoLinhasNaoEncontradas = false

function TabelaSimcardFaturas(props) {
  const [spinAtivo, setSpinAtivo] = useState(true)
  const [itens, setItens] = useState([])
  const [filtro_arquivo] = useState(false)
  const [paginaAtual, setPaginaAtual] = useState(1)
  const [renderizar, setRenderizar] = useState(false)
  const [permissaoDescricao, setPermissaoDescricao] = useState()
  const [arrayCdSimcard] = useState([])
  const [revelarMensagemInformacao, setRevelarMensagemInformacao] =
    useState(false)
  const [
    dadosParaDownloadLinhasNaoEncontradas,
    setDadosParaDownloadLinhasNaoEncontradas
  ] = useState([['Linha', 'ICCID']])
  const [
    renderDadosParaDownloadLinhasNaoEncontradas,
    setRenderDadosParaDownloadLinhasNaoEncontradas
  ] = useState(false)
  const [revelarContador, setRevelarContador] = useState(false)

  const [showCaption, setShowCaption] = useState(false)
  const [limpandoSelecao, setLimpandoSelecao] = useState(false)

  const [mensagemLimite, setMensagemLimite] = useState(false)
  const [revelarMensagemLimite, setRevelarMensagemLimite] = useState(false)
  const [mensagemSucesso, setMensagemSucesso] = useState(false)
  const [simcardsSelecionados, setSimcardsSelecionados] = useState([])
  const [cdSimcardsSelecionados, setCdSimcardsSelecionados] = useState([])

  const {
    modoSelecaoSimcard: reduxModoSelecaoSimcard,
    revelarExibirColunas,
    revelarImportarDescricao,
    realizouFiltro: realizouFiltragem,
    expandirNavegacao: estadoExpansaoMenu,
    conteudoBusca,
    limpouBusca: limpouBuscaGeral,
    realizouBusca: realizouBuscaGeral,
    ordenador,
    separadorLinha
  } = useSelector((state) => state.manejadorState)

  const {
    revelarAssociarFatura: associarFatura,
    revelarAlteracaoprazodepermanenciaFaturas:
      revelarAlterarPrazoPermanenciaVar,
    revelarDispositivosAlterarServicos: revelarDispositivosAlterarServicosVar,
    revelarDispositivosAlterarPlano: revelarDispositivosAlterarPlanoVar,
    revelarDispositivosAlterarCicloDeVida:
      revelarDispositivosAlterarCicloDeVidaVar,
    revelarResetFaturas: revelarResetFaturasVar,
    revelarLiberarSmsFaturas: revelarLiberarSmsFaturasVar,
    revelarDesativarSMSFaturas: revelarBloquearSmsFaturasVar,
    revelarDispositivosAlterarConta: revelarDispositivosAlterarContaVar,
    revelarAlterarICCIDFaturas: revelarDispositivosAlterarIccidVar,
    revelarRelatorioFaturaDispositivos: controladorRelatorioFaturaDispositivos
  } = useSelector((state) => state.faturasState)
  let revelarBarraFiltro = useSelector(
    (state) => state.filtrosState.revelarBarraFiltragem
  )
  const { filtros, limparFiltros } = useSelector((state) => state.filtrosState)

  const { buscaArquivo } = useSelector((state) => state.buscaArquivoState)

  const { permissaoElemento } = useSelector((state) => state.permissaoState)

  const despacho = useDispatch()
  let temFiltros = false

  const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

  const ultrapassouLimite =
    totalItens > limiteSolicitacoes && reduxModoSelecaoSimcard

  function fecharModalAcao() {
    if (revelarDispositivosAlterarCicloDeVidaVar) {
      despacho(revelarDispositivosAlterarCicloDeVida(false))
    } else if (revelarResetFaturasVar) {
      despacho(revelarResetFaturas(false))
    } else if (revelarLiberarSmsFaturasVar) {
      despacho(revelarLiberarSMSFaturas(false))
    } else if (revelarBloquearSmsFaturasVar) {
      despacho(revelarDesativarSMSFaturas(false))
    } else if (revelarDispositivosAlterarPlanoVar) {
      despacho(revelarDispositivosAlterarPlano(false))
    } else if (revelarDispositivosAlterarContaVar) {
      despacho(revelarDispositivosAlterarConta(false))
    } else if (revelarDispositivosAlterarServicosVar) {
      despacho(revelarDispositivosAlterarServicos(false))
    } else if (revelarAlterarPrazoPermanenciaVar) {
      despacho(revelarAlteracaoprazodepermanenciaFaturas(false))
    } else if (revelarDispositivosAlterarIccidVar) {
      despacho(revelarAlterarICCIDFaturas(false))
    }
    // else alterar iccid
  }

  function controleLimiteSimcardsNaSolicitacao() {
    if (
      ultrapassouLimite &&
      (revelarDispositivosAlterarCicloDeVidaVar ||
        revelarResetFaturasVar ||
        revelarLiberarSmsFaturasVar ||
        revelarBloquearSmsFaturasVar === true ||
        revelarDispositivosAlterarPlanoVar ||
        revelarDispositivosAlterarContaVar ||
        revelarDispositivosAlterarServicosVar ||
        revelarAlterarPrazoPermanenciaVar)
    ) {
      fecharModalAcao()

      setMensagemLimite(
        `Essa solicitação não permite mais de ${limiteSolicitacoes.toLocaleString()} SIM cards selecionados`
      )
      setRevelarMensagemLimite(true)
    }
  }
  controleLimiteSimcardsNaSolicitacao()

  function onClickSelecaoParqueTodo(novoValor) {
    if (novoValor === false) {
      desselecionarTodosCheckboxes('limparSelecao')

      setLimpandoSelecao(true)
      setShowCaption(false)
    }
    handleAlternarSelecao(novoValor)
  }

  useEffect(() => {
    if (coletaUsabilidade) {
      ColetaClickstream(1242) // 'fatFaturasDispositivos'
      setColetaUsabilidade(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    async function buscarDadosRelatorio() {
      setSpinAtivo(true)

      let hasFilters
      if (props.filtros.vazio == 'vazio') {
        hasFilters = false
      } else {
        hasFilters = true
      }

      await api_gateway
        .post('/m1/filtrar/fatSimcard', {
          cd_pav_usuario: decryptJWT('codigo'),
          filtros: filtros,
          buscaArquivo: buscaArquivo,
          buscar: conteudoBusca,
          simcards: arrayCdSimcard,
          modoSelecaoSimcard: reduxModoSelecaoSimcard,
          contar: false,
          relatorio: true,
          separador: separadorLinha
        })
        .then(function (resposta) {
          let arrayAuxSimcard = []
          if (resposta.data.dados != undefined) {
            resposta.data.dados.map((item) => {
              arrayAuxSimcard.push(item.CD_SIMCARD)
            })

            const dados = {
              codigo_cliente: decryptJWT('codigoCliente'),
              codigo_usuario: decryptJWT('codigo'),
              descricao: 'Relatório de dispositivos de faturas',
              tipo_arquivo: controladorRelatorioFaturaDispositivos,
              tipo_relatorio: 11,
              buscar: conteudoBusca,
              buscaArquivo,
              arrayCdSimcard: arrayAuxSimcard,
              separador: separadorLinha,
              parqueInteiro: reduxModoSelecaoSimcard,
              temFiltros: hasFilters
            }

            api_gateway.post('/m1/cadastrar/relatorios', dados)
            handleMensagemInformacao(true)
            despacho(revelarRelatorioFaturaDispositivos(false))
            return resposta.data.dados
          }
        })
        .catch(function (erro) {
          throw erro
        })
      setSpinAtivo(false)
    }
    if (
      controladorRelatorioFaturaDispositivos === 'XLS' ||
      controladorRelatorioFaturaDispositivos === 'XLSX' ||
      controladorRelatorioFaturaDispositivos === 'CSV'
    ) {
      buscarDadosRelatorio()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controladorRelatorioFaturaDispositivos])

  function handleMensagemInformacao() {
    if (revelarMensagemInformacao === false) {
      setRevelarMensagemInformacao(true)
    } else {
      setRevelarMensagemInformacao(false)
    }
  }

  function handleMensagemLimite() {
    if (revelarMensagemLimite === false) {
      setRevelarMensagemLimite(true)
    } else {
      setRevelarMensagemLimite(false)
    }
  }

  function handleMensagemSucesso(confirmacao, arrMsgSucesso) {
    if (mensagemSucesso === false) {
      setMensagemSucesso(arrMsgSucesso)
    } else {
      setMensagemSucesso(false)
    }
    if (confirmacao) {
      setRenderizar(!renderizar)
    }
  }

  async function handleMontarXlsLinhasNaoEncontradas(dados) {
    const dadosMontar = await montarXlsLinhasNaoEncontradas(dados)

    if (dadosMontar) {
      dadosParaDownloadLinhasNaoEncontradas.push(...dadosMontar)
      setRenderDadosParaDownloadLinhasNaoEncontradas(true) // provoca o useEffect abaixo (com renderDadosParaDownloadLinhasNaoEncontradas)
    }
  }

  function handleRespostaSolicitacao({ response, error }) {
    let arrMsgSucesso = {
      arrTexto: ['Sucesso', 'Solicitação enviada'],
      btnTexto: 'Continuar'
    }

    if (response) {
      // sucesso
      fecharModalAcao()

      const { linhasInvalidas } = response?.data
      const qtdInvalidas = linhasInvalidas?.length
      if (qtdInvalidas) {
        arrMsgSucesso = {
          arrTexto: [
            'Solicitação enviada',
            `Foram encontradas ${qtdInvalidas} linhas inválidas na sua solicitação. 
                            Todas as demais linhas foram incluídas.`,
            'Clique em baixar para verificar as linhas inválidas.'
          ],
          btnTexto: 'Fechar',
          linhasInvalidas
        }
      }

      handleMensagemSucesso(false, arrMsgSucesso)
    } else if (error) {
      const resp = error?.response
      const respDados = resp?.data
      const mensagemErro = respDados?.info

      if (mensagemErro && [400, 401].includes(resp?.status)) {
        return { atencao: mensagemErro }
      } else {
        console.error(error)
        return { erro: true }
      }
    }
  }

  function handleMensagemAtencao() {
    if (renderDadosParaDownloadLinhasNaoEncontradas) {
      clickBotaoInvisivelExportarLinhasNaoEncontradas()
      setRenderDadosParaDownloadLinhasNaoEncontradas(false)
      setDadosParaDownloadLinhasNaoEncontradas([['Linha', 'ICCID']])
    }
  }

  useEffect(() => {
    function checarFiltros() {
      if (props.filtros.vazio == 'vazio') {
        temFiltros = false
      } else {
        temFiltros = true
      }
    }
    checarFiltros()
  }, [filtros])

  useEffect(() => {
    despacho(modoSelecaoSimcard(false))
    alternadorSelecao = reduxModoSelecaoSimcard
    async function handlerVerificarPermissaoAcao() {
      const validarPermissoes = await validadorPermissaoElemento(
        permissaoElemento,
        'veye/dispositivos/faturas/acoes'
      )

      despacho(mudarPermissaoElementoAcao(!validarPermissoes))
      setPermissaoDescricao(
        await validadorPermissaoElemento(
          permissaoElemento,
          'veye/dispositivos/faturas/detalhamento'
        )
      )
    }
    handlerVerificarPermissaoAcao()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissaoElemento])

  useEffect(() => {
    restaurarConfigsIniciaisPagina()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.ordenador])

  useEffect(() => {
    async function pegarSeparador() {
      const separador = await api_gateway
        .get(
          '/m1/consultar/preferencias?cd_pav_usuario=' + decryptJWT('codigo')
        )
        .then(function (resposta) {
          return resposta.data.dados[0]
        })
        .catch(function (erro) {
          throw erro.stack
        })
      despacho(separadorLinhaBusca(separador.busca_separador))
    }

    pegarSeparador()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (limparFiltros) {
      if (!filtros.vazio) {
        despacho(mudarFiltros({ vazio: 'vazio' }))
        despacho(revelarBarraFiltragem(false))
        despacho(limpadorFiltros(false))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const controller = new AbortController()

    if (simcardsSelecionados.length === 0 && alternadorSelecao === false) {
      despacho(desabilitarAcoes(true))
    }

    // let data = new Date()
    // let ano = data.getFullYear()
    // let mes = data.getMonth() + 1
    // let dia = data.getDate()
    // let anoFormatado = String(ano)
    // let mesFormatado = mes < 10 ? '0' + String(mes) : String(mes)
    // let diaFormatado = dia < 10 ? '0' + String(dia) : String(dia)
    // let dataFormatada = anoFormatado + '-' + mesFormatado + '-' + diaFormatado

    async function carregarTabela() {
      let desselecionarCheckboxAposRecarregarTabela = false

      setSpinAtivo(true)

      // if (ciclo === undefined) {
      //   ciclo = await api_gateway.get(
      //     '/m1/consultar/ciclo?dt_data=' + dataFormatada
      //   )
      //   setCicloAtual(ciclo)
      // }

      //clicou no botão de limpar a busca geral e retorna tudo ao estado original
      if (limpouBuscaGeral) {
        despacho(limpouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão de busca geral
      if (realizouBuscaGeral) {
        despacho(realizouBusca(false))
        restaurarConfigsIniciaisPagina()
      }

      //clicou no botão para filtro
      if (realizouFiltragem) {
        despacho(realizouFiltro(false))
        restaurarConfigsIniciaisPagina()
      }

      //necessario para pegar os dados do filtro, pois por algum motivo ele se perde e nao aciona os props.filtros
      if (temFiltros) {
        temFiltros = false
        restaurarConfigsIniciaisPagina()
      }

      setItens([])

      if (totalPaginas != 0) {
        contador = (paginaAtual - 1) * valorLimite
      }

      const limparBuscaPorArquivo = () => despacho(mudarBuscaArquivo({}))

      let buscaArquivoStr = JSON.stringify(buscaArquivo)
      if (filtros?.ICCID && buscaArquivo?.chave) {
        buscaArquivoStr = '{}'
        limparBuscaPorArquivo()
      }

      // CONTADOR
      if (totalPaginas == 0 || props?.buscaArquivo?.chave) {
        // solicitações precisa disso?
        setRevelarContador(false)
        let arrayItens = []
        let apiData = []

        const urlGet = `/m1/filtrar/fatSimcard?buscar=${conteudoBusca}&contar=${true}&separador=${separadorLinha}&carregarLimit=${valorLimite}&paguinaAtual=${contador}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${buscaArquivoStr}&cd_pav_usuario=${decryptJWT('codigo')}`
        apiData = await api_gateway.get(urlGet, { signal: controller.signal })

        totalItens = apiData.data.dados[0].CONTADOR
        totalPaginas = Math.ceil(totalItens / valorLimite)
        for (var i = 0; i < totalItens; i++) {
          arrayItens.push(i)
        }

        itensVar = arrayItens

        setRevelarContador(true)
        despacho(RevelarBuscarEFiltro(true))

        // ---------------------------------------
        desselecionarCheckboxAposRecarregarTabela = true
      }

      const aindaNaoGerouArquivoLinhasNaoEncontradas = (chave) =>
        chaveArquivoLinhasNaoEncontradas !== chave

      if (
        props.conteudoBusca &&
        props.filtros.vazio &&
        !props.buscaArquivo?.chave
      ) {
        const urlGet = `/m1/filtrar/fatSimcard?paguinaAtual=${contador}&carregarLimit=${valorLimite}&buscar=${conteudoBusca}&ordenador=${ordenador}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${buscaArquivoStr}&separador=${separadorLinha}&contar=false&cd_pav_usuario=${decryptJWT('codigo')}`

        if (controladorPagina <= paginaAtual) {
          const simcards = await api_gateway
            .get(urlGet, { signal: controller.signal })
            .then(function (resposta) {
              return resposta.data.dados
            })
            .catch(function (erro) {
              throw erro.stack
            })

          inserirData(simcards)
        }
      } else if (!props.filtros.vazio && !buscaArquivo.VALIDADOR_ARQUIVO) {
        const urlGet = `/m1/filtrar/fatSimcard?paguinaAtual=${contador}&carregarLimit=${valorLimite}&buscar=${conteudoBusca}&ordenador=${ordenador}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${buscaArquivoStr}&separador=${separadorLinha}&contar=false&cd_pav_usuario=${decryptJWT('codigo')}`

        if (controladorPagina <= paginaAtual) {
          const simcards = await api_gateway
            .get(urlGet, { signal: controller.signal })
            .then(function (resposta) {
              return resposta.data
            })
            .catch(function (erro) {
              throw erro.stack
            })

          if (simcards.data?.arquivo && simcards.data.status == 200) {
            handleMontarXlsLinhasNaoEncontradas(simcards.data.arquivo)
          }

          inserirData(simcards.dados)
        }
      } else if (
        props.buscaArquivo &&
        buscaArquivo.VALIDADOR_ARQUIVO &&
        aindaNaoGerouArquivoLinhasNaoEncontradas(buscaArquivo.chave)
      ) {
        chaveArquivoLinhasNaoEncontradas = buscaArquivo.chave

        // armazena a chave e o código do usuario, para consultar no BD
        // as linhas ou iccids enviados no filtro arquivo
        const dados = {
          chave: buscaArquivo.chave,
          usuario: decryptJWT('codigo')
        }

        // Faz a consulta ao BD e retorna TODOS OS ITENS ENVIADOS NO ARQUIVO DE FILTRO POR ARQUIVO
        const { data: dataLinhasNaoEncontradas } = await api_gateway.post(
          '/m1/filtrar/fat_iccid_ou_linhas_nao_encontrados',
          dados
        )

        // Esta consulta retorna os itens ENCONTRADOS no BD
        async function filtrarFatSimcard(urlGet) {
          return api_gateway
            .get(urlGet, { signal: controller.signal })
            .then(function (resposta) {
              return resposta.data
            })
            .catch(function (erro) {
              throw erro.stack
            })
        }

        if (controladorPagina <= paginaAtual) {
          let urlGet = `/m1/filtrar/fatSimcard?filtros=${JSON.stringify(filtros)}&buscaArquivo=${buscaArquivoStr}&separador=${separadorLinha}&contar=false&cd_pav_usuario=${decryptJWT('codigo')}`

          const simcards = await filtrarFatSimcard(
            urlGet + `&campos=CALLERID,ICCID`
          ) // traz só iccids e linhas

          // variáveis auxiliares

          // Monta um array com os dados retornados do BD,
          // caso encontrado algum registro de ICCID/LINHA relevante a busca
          if (simcards.dados !== undefined) {
            const listaIccids = await getListaIccidsNaoEncontrados({
              dataLinhasNaoEncontradas,
              simcards
            })
            handleMontarXlsLinhasNaoEncontradas(listaIccids)

            const listaLinhas = await getListaLinhasNaoEncontradas({
              dataLinhasNaoEncontradas,
              simcards
            })
            handleMontarXlsLinhasNaoEncontradas(listaLinhas)

            // Para que ele não faça download do mesmo arquivo
            // limpamos os filtros
            despacho(limpadorFiltros(true))
          }

          const simcards2 = await filtrarFatSimcard(
            urlGet + `&carregarLimit=${valorLimite}&paguinaAtual=${contador}`
          )
          if (simcards2?.dados) inserirData(simcards2.dados)
        }
      } else {
        const urlGet = `/m1/filtrar/fatSimcard?paguinaAtual=${contador}&carregarLimit=${valorLimite}&buscar=${conteudoBusca}&ordenador=${ordenador}&filtros=${JSON.stringify(filtros)}&buscaArquivo=${buscaArquivoStr}&separador=${separadorLinha}&contar=false&cd_pav_usuario=${decryptJWT('codigo')}`

        if (controladorPagina <= paginaAtual) {
          const simcards = await api_gateway
            .get(urlGet, { signal: controller.signal })
            .then(function (resposta) {
              return resposta.data.dados
            })
            .catch(function (erro) {
              throw erro.stack
            })

          inserirData(simcards)
        }
      }

      // quando altera dados da tabela e precisa desselecionar ----------
      if (
        desselecionarCheckboxAposRecarregarTabela &&
        !simcardsSelecionados?.length
      ) {
        if (alternadorSelecao) {
          onClickSelecaoParqueTodo(false)
        } else {
          desselecionarTodosCheckboxes()
        }
      }
    }
    carregarTabela()

    return () => {
      controller.abort()
    }
  }, [
    paginaAtual,
    props.conteudoBusca,
    renderizar,
    props.filtros,
    props.buscaArquivo,
    ordem,
    props.ordenador
  ])

  function inserirData(data) {
    for (let i = 0; i < totalItens; i++) {
      if (contador === i) {
        let k = i
        for (let j = 0; j < data.length; j++) {
          itensVar[k] = data[j]
          k++
        }
      }
      if (i == totalItens - 1) {
        setItens(JSON.parse(JSON.stringify(itensVar)))
      }
    }
    setSpinAtivo(false)

    if (limpandoSelecao) {
      clickDesselecionarCheckboxVerde(false)
    }
  }

  //Enconta dentro dos itens da tabela o item ao qual vai ser ter a linha expandida
  function mapearDadoDetalhamentoLinha(dados) {
    let detalhamento = ''
    itens.map((item_simcard) => {
      if (item_simcard.CD_SIMCARD === dados.CD_SIMCARD) {
        detalhamento = item_simcard
      }
    })
    return [detalhamento]
  }

  function handleSelecionarTodosSimcards(rows) {
    rows.map((item, i) => {
      simcardsSelecionados.push(rows[i])
      arrayCdSimcard.push(rows[i].CD_SIMCARD)
    })
    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }
  function handleDesselecionarTodosSimcards(rows) {
    rows.map((item, i) => {
      simcardsSelecionados.map((simcards, x) => {
        if (rows[i].CD_SIMCARD === simcardsSelecionados[x].CD_SIMCARD) {
          simcardsSelecionados.splice(x, 1)
          arrayCdSimcard.splice(x, 1)
        }
      })
    })
    if (simcardsSelecionados.length === 0) {
      setSimcardsSelecionados([])
      setCdSimcardsSelecionados([])

      despacho(desabilitarAcoes(true))
    }
  }

  function handleSelecionarSimcard(simcard) {
    for (let i = 0; i < itens.length; i++) {
      if (itens[i].CD_SIMCARD === simcard.CD_SIMCARD) {
        simcardsSelecionados.push(itens[i])
        arrayCdSimcard.push(itens[i].CD_SIMCARD)
        operadorasSelecionadas.push(itens[i].DS_PEDIDO_OPERADORA)
        break
      }
    }

    despacho(desabilitarAcoes(false))
    despacho(desabilitarAcoesCliente(true))
  }

  function handleDesselecionarSimcard(simcard) {
    for (let i = 0; i < simcardsSelecionados.length; i++) {
      if (simcardsSelecionados[i].CD_SIMCARD === simcard) {
        simcardsSelecionados.splice(i, 1)
        arrayCdSimcard.splice(i, 1)
        operadorasSelecionadas.splice(i, 1)
        break
      }
    }
    if (simcardsSelecionados.length == 0) {
      despacho(desabilitarAcoes(true))
    }
  }

  function restaurarConfigsIniciaisPagina() {
    totalPaginas = 0
    contador = 0
    controladorPagina = 1
    totalItens = 50
    setSimcardsSelecionados([])
    setCdSimcardsSelecionados([])
    despacho(desabilitarAcoes(true))
    despacho(desabilitarAcoesCliente(true))
    setPaginaAtual(1)
  }

  function handleAlternarSelecao(valor) {
    alternadorSelecao = valor
    despacho(modoSelecaoSimcard(valor))
    if (valor) {
      despacho(desabilitarAcoes(false))
      despacho(desabilitarAcoesCliente(true))
    } else {
      despacho(desabilitarAcoes(true))
      despacho(desabilitarAcoesCliente(false))
    }

    setSimcardsSelecionados([])
    setCdSimcardsSelecionados([])
  }

  const renderDetalhamentoLinha = (row) => {
    return (
      <div
        className={
          estadoExpansaoMenu === true
            ? 'expand-row-tabela-dispositivos-1'
            : 'expand-row-tabela-dispositivos-2'
        }
      >
        <Detalhamento
          renderConsultaColunas={props.render}
          setRenderConsultaColunas={props.setRender}
          row={mapearDadoDetalhamentoLinha(row)}
          cdSimcard={row.CD_SIMCARD}
          gsm={row.FULLCALLERID}
          previsaoConsumo={row.PREVISAO}
          plano={row.PLANO + row.EXCEDENTE}
          cdPlano={row.CD_PLANO}
          renderizar={renderizar}
          setRenderizar={setRenderizar}
        />
      </div>
    )
  }

  const handleOnSelect = (row, isSelect) => {
    if (limpandoSelecao) setLimpandoSelecao(false)

    if (isSelect) {
      setCdSimcardsSelecionados((prev) => [...prev, row.CD_SIMCARD])
      handleSelecionarSimcard(row)
    } else {
      setCdSimcardsSelecionados((prev) =>
        prev.filter((id) => id !== row.CD_SIMCARD)
      )
      handleDesselecionarSimcard(row.CD_SIMCARD)
      if (showCaption) setShowCaption(false)
    }
  }

  const handleOnSelectAll = (isSelect, rows) => {
    if (limpandoSelecao) setLimpandoSelecao(false)

    if (isSelect && !limpandoSelecao) {
      const allIds = rows.map((r) => r.CD_SIMCARD)
      setCdSimcardsSelecionados((prev) => [...prev, ...allIds])
      handleSelecionarTodosSimcards(rows)
      setShowCaption(true)
    } else {
      setCdSimcardsSelecionados((prev) =>
        prev.filter((id) => !rows.some((r) => r.CD_SIMCARD === id))
      )
      handleDesselecionarTodosSimcards(rows)
      desselecionarTodosCheckboxes('limparSelecao')
      if (showCaption) setShowCaption(false)
    }
  }

  const getLimiteNaPagina = () =>
    contador + valorLimite <= totalItens ? contador + valorLimite : totalItens
  const getTotalItensNaPagina = () => getLimiteNaPagina()

  const trocarPagina = (novaPagina) => {
    if (totalPaginas <= 1) return

    setPaginaAtual(novaPagina)
  }

  return (
    <>
      <Table
        keyField="CD_SIMCARD"
        enableDrag
        clickToSelect
        itens={itens}
        colunas={props.colunas}
        revelarBarraFiltro={revelarBarraFiltro}
        permissaoDetalhamentoLinha={permissaoDescricao}
        detalhamentLinha={renderDetalhamentoLinha}
        spinAtivo={spinAtivo}
        showCaption={showCaption}
        setShowCaption={setShowCaption}
        revelarContador={revelarContador}
        getTotalItensNaPagina={getTotalItensNaPagina}
        getLimiteNaPagina={getTotalItensNaPagina}
        pagination={{
          paginaAtual,
          valorLimite,
          totalPaginas,
          totalItens,
          contador,
          trocarPagina,
          onDragEnd: props.onDragEnd
        }}
        selection={{
          itensSelecionados: cdSimcardsSelecionados,
          modeSelection: 'checkbox',
          handleOnSelect,
          handleOnSelectAll,
          onClickSelecaoParqueTodo
        }}
      />
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <BotaoInvisivelExportarLinhasNaoEncontradas
        {...{ dadosParaDownloadLinhasNaoEncontradas }}
      />
      <div className="container-tela">
        {revelarMensagemInformacao && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <MensagemInformacao
                handleMensagemInformacao={handleMensagemInformacao}
                mensagemTitulo="O arquivo está sendo gerado"
                mensagemParagrafo1="Esse processo levará alguns minutos, você poderá fazer o download do seu arquivo na tela de relatórios assim que o link do mesmo estiver disponível"
                mensagemBotao="Voltar"
              />
            </div>
          </div>
        )}
        {revelarMensagemLimite && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <MensagemAtencao
                handleMensagemAtencao={handleMensagemLimite}
                mensagemTitulo="Atenção"
                mensagemParagrafo1={mensagemLimite}
                mensagemBotao="FECHAR"
              />
            </div>
          </div>
        )}
        {mensagemSucesso && (
          <RenderMensagemSucesso
            {...{ mensagemSucesso, handleMensagemSucesso }}
          />
        )}
        {renderDadosParaDownloadLinhasNaoEncontradas && (
          <AtencaoBaixarArquivoLinhasNaoEncontradas
            {...{
              handleMensagemAtencao,
              dadosParaDownloadLinhasNaoEncontradas
            }}
          />
        )}
        {revelarDispositivosAlterarCicloDeVidaVar && !ultrapassouLimite && (
          <>
            <div className="componente-modal-overlay">
              <div className="componente-modal">
                <AlterarCicloDeVida
                  renderizar={renderizar}
                  setRenderizar={setRenderizar}
                  simcardsSelecionados={simcardsSelecionados}
                  operadorasSelecionadas={operadorasSelecionadas}
                  cdSimcardsArquivo={simcardsArray}
                  handleRespostaSolicitacao={handleRespostaSolicitacao}
                />
              </div>
            </div>
          </>
        )}
        {revelarDispositivosAlterarContaVar && !ultrapassouLimite && (
          <>
            <div className="componente-modal-overlay">
              <div className="componente-modal">
                <AlterarConta
                  renderizar={renderizar}
                  setRenderizar={setRenderizar}
                  simcardsSelecionados={simcardsSelecionados}
                  operadorasSelecionadas={operadorasSelecionadas}
                  cdSimcardsArquivo={simcardsArray}
                  handleRespostaSolicitacao={handleRespostaSolicitacao}
                />
              </div>
            </div>
          </>
        )}
        {revelarDispositivosAlterarIccidVar && ( // !ultrapassouLimite &&
          <>
            <div className="componente-modal-overlay">
              <div className="componente-modal">
                <AlterarIccid
                  renderizar={renderizar}
                  setRenderizar={setRenderizar}
                  simcardsSelecionados={simcardsSelecionados}
                  operadorasSelecionadas={operadorasSelecionadas}
                  cdSimcardsArquivo={simcardsArray}
                  handleRespostaSolicitacao={handleRespostaSolicitacao}
                />
              </div>
            </div>
          </>
        )}
        {revelarResetFaturasVar && !ultrapassouLimite && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <Reset
                renderizar={renderizar}
                setRenderizar={setRenderizar}
                itensSelecionados={simcardsSelecionados}
                handleRespostaSolicitacao={handleRespostaSolicitacao}
              />
            </div>
          </div>
        )}
        {revelarLiberarSmsFaturasVar && !ultrapassouLimite && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <LiberarSms
                renderizar={renderizar}
                setRenderizar={setRenderizar}
                itensSelecionados={simcardsSelecionados}
                handleRespostaSolicitacao={handleRespostaSolicitacao}
              />
            </div>
          </div>
        )}
        {revelarBloquearSmsFaturasVar === true && !ultrapassouLimite && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <BloquearSms
                renderizar={renderizar}
                setRenderizar={setRenderizar}
                itensSelecionados={simcardsSelecionados}
                handleRespostaSolicitacao={handleRespostaSolicitacao}
              />
            </div>
          </div>
        )}
        {revelarDispositivosAlterarPlanoVar && !ultrapassouLimite && (
          <>
            <div className="componente-modal-overlay">
              <div className="componente-modal">
                <AlterarPlano
                  renderizar={renderizar}
                  setRenderizar={setRenderizar}
                  simcardsSelecionados={simcardsSelecionados}
                  operadorasSelecionadas={operadorasSelecionadas}
                  cdSimcardsArquivo={simcardsArray}
                  filtro_simcard={filtro_arquivo}
                  handleRespostaSolicitacao={handleRespostaSolicitacao}
                />
              </div>
            </div>
          </>
        )}
        {revelarDispositivosAlterarServicosVar && !ultrapassouLimite && (
          <>
            <div className="componente-modal-overlay">
              <div className="componente-modal">
                <AlterarServico
                  renderizar={renderizar}
                  setRenderizar={setRenderizar}
                  simcardsSelecionados={simcardsSelecionados}
                  operadorasSelecionadas={operadorasSelecionadas}
                  cdSimcardsArquivo={simcardsArray}
                />
              </div>
            </div>
          </>
        )}
        {revelarImportarDescricao === true && ( // !ultrapassouLimite &&
          <>
            <div className="componente-modal-overlay">
              <div className="componente-modal">
                <ImportarDescricao
                  setRenderizar={setRenderizar}
                  renderizar={renderizar}
                />
              </div>
            </div>
          </>
        )}
        {revelarExibirColunas === true && (
          <>
            <div className="componente-modal-overlay">
              <div className="componente-modal">
                <PersonalizarColunasFaturas
                  render={props.render}
                  setRender={props.setRender}
                  setRenderizar={setRenderizar}
                  renderizar={renderizar}
                />
              </div>
            </div>
          </>
        )}
        {associarFatura === true && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <ModalAssociarClientes
                // cdFatFebraban={cdFatFebraban}
                tituloJanela="Associar"
                setRenderizar={setRenderizar}
                renderizar={renderizar}
              />
            </div>
          </div>
        )}
        {revelarAlterarPrazoPermanenciaVar === true && !ultrapassouLimite && (
          <div className="componente-modal-overlay">
            <div className="componente-modal">
              <AlterarPrazoPermanencia
                setRenderizar={setRenderizar}
                renderizar={renderizar}
                simcardsSelecionados={simcardsSelecionados}
                handleRespostaSolicitacao={handleRespostaSolicitacao}
              />
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default memo(TabelaSimcardFaturas)
